import React from "react";

const QuestionLabel = ({ questionNumber, pollMode, prefix }) => {
    return (
        <>
            {
                pollMode ?

                "Poll"

                :

                prefix + questionNumber
            }
        </>
    );
}

export default QuestionLabel;